import type { GoogleMapInstance, GoogleMapsApi, LatLngLiteral, MapPolyline } from '@/shared/google/googleMaps'

/**
 * Parcours prévu de la route (validé au bureau, figé dans la mission) : trait épais à la couleur de la route, contour
 * foncé et flèches de sens régulières, lisible en satellite, en routière et en perspective. La portion parcourue
 * n'est atténuée que lorsque la progression est confirmée. Distinct de la trace GPS enregistrée et de l'itinéraire
 * suggéré (tireté violet).
 */
export interface RoutePathLayer {
  update: (model: { remaining: LatLngLiteral[][]; travelled: LatLngLiteral[][]; color: string } | null) => void
  destroy: () => void
}

export function createRoutePathLayer(api: GoogleMapsApi, map: GoogleMapInstance): RoutePathLayer {
  let lines: MapPolyline[] = []
  const clear = () => {
    for (const line of lines) line.setMap(null)
    lines = []
  }
  return {
    update(model) {
      clear()
      if (!model) return
      for (const path of model.travelled) {
        if (path.length < 2) continue
        lines.push(
          new api.Polyline({ map, path, clickable: false, strokeColor: model.color, strokeOpacity: 0.35, strokeWeight: 7, zIndex: 2 }),
        )
      }
      for (const path of model.remaining) {
        if (path.length < 2) continue
        lines.push(
          new api.Polyline({ map, path, clickable: false, strokeColor: '#0B0F1A', strokeOpacity: 0.9, strokeWeight: 13, zIndex: 3 }),
          new api.Polyline({
            map,
            path,
            clickable: false,
            strokeColor: model.color,
            strokeOpacity: 1,
            strokeWeight: 8,
            zIndex: 4,
            icons: [
              {
                icon: {
                  path: api.SymbolPath.FORWARD_CLOSED_ARROW,
                  scale: 3,
                  strokeColor: '#0B0F1A',
                  strokeWeight: 1.5,
                  fillColor: '#FFFFFF',
                  fillOpacity: 1,
                },
                offset: '40px',
                repeat: '120px',
              },
            ],
          }),
        )
      }
    },
    destroy: clear,
  }
}
